<template>
  <i18n-t :class="[accent]" :locale="lang" keypath="Forms.GDPR.USA" tag="p">
    <LinkPrivacyNotice :accent :lang />
  </i18n-t>

  <p>{{ t('Forms.GDPR.unsubscribe') }}</p>
</template>

<script setup lang="ts">
// components
import LinkPrivacyNotice from '~/components/redesign/LinkPrivacyNotice.vue';

// composables
import { useLangT } from '~/composables';

const props = withDefaults(
  defineProps<{
    accent?: 'dark' | 'light';
    lang?: string;
  }>(),
  {
    accent: 'dark',
  },
);

const t = useLangT(props.lang);
</script>

<style scoped lang="scss">
@use '_/mixins/typo';
@use '_/fn';

p {
  @include typo.caption;

  &.dark {
    color: fn.token('text-primary');
  }

  &.light {
    color: fn.token('text-reversed');
  }

  padding-bottom: 0.5rem;
}
</style>
